export default __webpack_public_path__ + "static/media/twitter.ab9d364f.svg";